import palette from '../../theme/palette';

export const styles = {
  header: {
    background: palette.sidebarBg,
    color: palette.white,
    borderRadius: '10px 10px 0 0',
  },
  checkboxLabel: {
    color: palette.white,
  },
  checkboxIcon: {
    fill: palette.white,
    marginRight: 7,
  },
};
